<script setup>
import { ref, useSlots } from "vue";

defineProps({
  centerBody: {
    type: Boolean,
    default: false
  },
  fixedHeight: {
    type: Boolean,
    default: false
  }
});
const slots = useSlots();
const hasQuestionSlot = ref(slots.question && slots.question().length);
const hasFooterSlot = ref(slots.footer && slots.footer().length);
</script>

<template>
  <div
    class="class-quiz-base-layout-container"
    :class="{ 'class-quiz-base-layout-container--fixed-height': fixedHeight }"
  >
    <section>
      <slot name="jumbotron" />
    </section>
    <section class="class-quiz-base-layout-body" :class="{ 'justify-content-center': centerBody }">
      <div v-if="hasQuestionSlot">
        <slot name="question" />
      </div>
      <slot />
    </section>
    <footer v-if="hasFooterSlot" class="class-quiz-base-layout-footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.class-quiz-base-layout-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  &--fixed-height {
    height: calc(100vh - 58px); // 58px = height of header
  }
}

.class-quiz-base-layout-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-top: 5vmin;
  padding-bottom: 5vmin;
  overflow: auto;
}

.class-quiz-base-layout-footer {
  padding: 2vmin 0;
  border-top: 1px solid rgb(@theme-colors[@grey][50]);

  #media-breakpoint-up(md, {
    padding: 3.25vmin 0;
  });
}
</style>
